import React from 'react';
import './home.css';

const Home = () => {
    return (
        <div id="home" className="home">

            <section class="section business-overview">
                <h2>Daou Bureau d'Etudes</h2>
                <p>D-BE offre des services d’ingénieur en construction pour l’étude de vos projets, de la conception à la réalisation</p>
            </section>


            <section class="section services">
                <h2>Nos Services</h2>
                <div class="service-list">
                    <div class="service-item">
                        <h3>Etude de stabilité des structures (Bois – Acier – Béton)</h3>
                    </div>
                    <div class="service-item">
                        <h3>Expertise des bâtiments</h3>
                    </div>
                    <div class="service-item">
                        <h3>Coordination des travaux</h3>
                    </div>
                    <div class="service-item">
                        <h3>Evaluation budgétaire</h3>
                    </div>
                </div>
            </section>

            <section class="section contact">
                <h2>Contact</h2>
                <div class="contact-details">
                    <div class="email">
                        <span>Adresse mail: </span> luc.daou@daou-be.be
                    </div>
                    <div class="phone">
                        <span>Téléphone:</span> +32477 794 073
                    </div>
                    <div class="address">
                        <span>Addresse:</span> Rue du Roy 10, 6670 Limerlé
                    </div>
                    <div class="n-tva">
                        <span>N°TVA:</span> BE1020227984
                    </div>
                </div>
            </section>




        </div>
    );
};

export default Home;
